function sizeSymbolConvert(chosen_variant_span, option_index) {
  const size_text = {
    "X-S": "X-Small",
    XS: "X-Small",
    S: "Small",
    M: "Medium",
    L: "Large",
    "X-L": "X-Large",
    XL: "X-Large",
  };
  let size_symbol = $(
    `.swatch-elements-list-${option_index} input:checked`
  ).val();

  chosen_variant_span.textContent = size_text[size_symbol];
}

$(document).ready(() => {
  const chosenVariants = document.querySelectorAll(".chosen-variant-name");

  Array.from(chosenVariants).forEach((chosen_variant, option_index) => {
    // Sets default selected variant's name to the chosen-variant-name-{optionIndex} span's textContent when page loaded
    // if()
    sizeSymbolConvert(chosen_variant, option_index);

    // Sets the user-selected variant's name to the chosen-variant-name-{optionIndex} span's textContent
    $(`.swatch-elements-list-${option_index} input`).change(() => {
      sizeSymbolConvert(chosen_variant, option_index);
    });
  });
});
